<onboarding-container [loading]="facade.sendingPassword$ | async" [hideLogout]="true" [hideBack]="true" [hideForward]="true">
  <p class="zero-text p-huge-med">{{ 'onboarding.password.headline' | transloco }}</p>
  <web-design-system-input
    type="password"
    [label]="'onboarding.password.password-placeholder' | transloco"
    [value]="password$ | async"
    (valueChange)="handlePasswordChange($event)"
    [isValid]="password$ | async | password"
    [error]="(password$ | async | password) === false ? ('register.sign-up.password.error' | transloco) : null"
    class="d-block mt-4"
    data-zid="password"
  />
  <web-design-system-input
    type="password"
    [label]="'onboarding.password.password-repeat-placeholder' | transloco"
    [value]="passwordRepeat$ | async"
    (valueChange)="handlePasswordRepeatChange($event)"
    [isValid]="passwordRepeat$ | async | passwordRepeat: (password$ | async)"
    [error]="
      (passwordRepeat$ | async | passwordRepeat: (password$ | async)) === false ? ('register.sign-up.password2.error1' | transloco) : null
    "
    class="d-block mt-3"
    data-zid="password-repeat"
  />
  <web-design-system-notification color="blue" class="d-block mt-3">
    {{ 'onboarding.password.notification' | transloco }}
  </web-design-system-notification>
  @if (facade.sentPasswordError$ | async; as error) {
    <div class="zero-text course-red my-3">{{ error | transloco }}</div>
  }
  <div class="d-flex justify-content-end align-items-center mt-4">
    <web-design-system-button data-zid="next" [disabled]="(isFormValid$ | async) === false" [fullwidth]="true" (click)="submit()">
      {{ 'onboarding.next' | transloco }}
    </web-design-system-button>
  </div>
</onboarding-container>
